module.exports = __webpack_public_path__ + "images/emails/smtp-678651eb.png";